import BaseCrudService from './baseCrud.service'

class ApartmentDataService extends BaseCrudService {
  constructor () {
    super('apartmentData', {
      id: false,
      apartment_id: '',
      floor: '',
      area: '',
      refurbishment: '',
      price: '',
      rent_month: '',
      rent_year: '',
      status: 1,
      created_by: 1
    })
  }

  create (parentId, data, ...callbacks) {
    this.constructor.post(this.endpoints().create.replace('{:parent}', parentId), data, ...callbacks)
  }

  update (parentId, itemId, data, ...callbacks) {
    this.constructor.put(this.endpoints().update.replace('{:parent}', parentId).replace('{:id}', itemId), data, ...callbacks)
  }
}

export default ApartmentDataService
